import resume from '../assets/pdf/resume.pdf'
import navi from '../assets/png/navi.jpg'

export const headerData = {
    name: 'Navipriya S',
    title: "Software Developer",
    desciption:"Coding transcends commands and syntax; it's about realizing ideas with determination. As a software developer, I empower creativity through code, shaping the digital world. Each project is an opportunity to innovate, inspire, and make an impact.",
    image: navi,
    resumePdf: resume
}
